import { ParsedPreset } from '@aibees/shared/definition';
import type { AdvanceTableActionProps } from '@aibees/shared/features';

export interface SaveSearchTableActionProps
  extends AdvanceTableActionProps<ParsedPreset<any>> {
  className?: string;
}

export enum SavedSearchTableActionType {
  view,
  edit,
  delete,
}
